import { api } from "@/redux/api";

import {
	BlacklistOverrideApplyRequest,
	BlacklistOverridePreviewRequest,
	BlacklistOverrideResult,
	BlacklistOverrideResultSchema,
	BlacklistOverrideVerdict,
	BlacklistOverrideVerdictListSchema,
} from "../../pages/Blacklist/schema/blacklist-override";

/**
 * Taking blacklisted leads off the blacklist to contact them (PREC-2548). The API decides per lead
 * what may be removed (`BlacklistOverrideService`); the web asks through the shared
 * `useBlacklistOverrideGate` and never decides on its own.
 */
export const blacklistOverrideApi = api.injectEndpoints({
	endpoints: (builder) => ({
		// A read, but a POST (the ids travel in the body), so a mutation: asked fresh on every gate
		// rather than answered from a cache that predates the last removal.
		previewBlacklistOverride: builder.mutation<
			BlacklistOverrideVerdict[],
			BlacklistOverridePreviewRequest
		>({
			query: (body) => ({
				url: "blacklist-override/preview",
				method: "POST",
				body,
				responseSchema: BlacklistOverrideVerdictListSchema,
			}),
		}),
		// Moves the overridden leads to Found (or Unsure) and removes their entries, so the list
		// table, its counts, the Contacts blacklist and the blacklist pages all change.
		applyBlacklistOverride: builder.mutation<
			BlacklistOverrideResult,
			BlacklistOverrideApplyRequest
		>({
			query: (body) => ({
				url: "blacklist-override/apply",
				method: "POST",
				body,
				responseSchema: BlacklistOverrideResultSchema,
			}),
			invalidatesTags: ["Blacklist", "List", "ListPerson", "Contact"],
		}),
	}),
});

export const { usePreviewBlacklistOverrideMutation, useApplyBlacklistOverrideMutation } =
	blacklistOverrideApi;
